import script from "./FloatingIcons.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingIcons.vue?vue&type=script&setup=true&lang=js"

import "./FloatingIcons.vue?vue&type=style&index=0&id=8b676678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b676678"]])

export default __exports__